import { render, staticRenderFns } from "./OrderScoring.vue?vue&type=template&id=1c28ec4f&"
import script from "./OrderScoring.vue?vue&type=script&lang=js&"
export * from "./OrderScoring.vue?vue&type=script&lang=js&"
import style0 from "./OrderScoring.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports